<template>

    <aside class="popup-external-link">
        <div
                class="popup-overlay"
                v-if="$root.states.popupExternalLinkHref"
        >
            <div class="popup">
                <div class="popup-body">

                    <h4>
                        Hinweis:
                    </h4>

                    <p>
                        Sie haben einen Link ausgewählt, der Sie auf eine nicht von Gilead Sciences betriebene Website führt.
                        Klicken Sie auf „Abbrechen“, um auf dieser Seite zu verbleiben, oder auf „Weiter“, um auf die neue Seite
                        zu gelangen.
                    </p>

                </div>
                <div class="popup-footer">
                    <button
                            type="button"
                            class="btn btn-pink-white-black-white"
                            v-on:click="cancelPopup()"
                    >
                        Abbrechen
                    </button>
                    <button
                            type="button"
                            class="btn btn-pink-white-black-white"
                            v-on:click="confirmPopup()"
                    >
                        Weiter
                    </button>
                </div>
            </div>
        </div>
    </aside>

</template>

<script>

    // console.log('PopupExternalLink');

    export default {
        created(){
            window.addEventListener('keyup', this.onKeyEscape);
        },
        destroyed(){
            window.removeEventListener('keyup', this.onKeyEscape);
        },
        components : {},
        methods : {
            cancelPopup(){
                this.$root.states.popupExternalLinkHref = null;
            },
            confirmPopup(){
                const href = this.$root.states.popupExternalLinkHref;
                if (href.indexOf('facebook.com') !== -1 || href.indexOf('facebook.de') !== -1) {
                    window.open(href, 'facebook', 'left=50,top=50,width=670,height=348');
                } else if (href.toLowerCase().indexOf('whatsapp://') !== -1 || href.toLowerCase().indexOf('api.whatsapp.com') !== -1) {
                    window.open(href, 'whatsapp', 'left=50,top=50,width=800,height=600');
                } else {
                    const a = document.createElement('a');
                    a.href = href;
                    a.target = '_blank';
                    a.rel = 'noopener';
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                }
                this.$root.states.popupExternalLinkHref = null;
            },
            onKeyEscape(event){
                if (event.key === 'Escape') {
                    this.cancelPopup();
                }
            },
        },
    }

</script>

<style lang="scss">

    @import '../../css/variables';

    .popup-external-link {
        z-index: 2000;
        .popup-overlay {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            position: fixed;
            left: 0;
            top: 0;
            width: 100%;
            height: 100vh;
            padding: 2rem;
            background-color: transparentize($color-nochvielvor-black, 0.1);
            @media screen and (max-width: 767px) {
                padding: 1.5rem;
            }
            @media screen and (min-width: 1200px) {
                padding: 2rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
                padding: 2rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
                padding: 2rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
                padding: 2rem * $factor-2400;
            }
        }
        .popup {
            width: 100%;
            max-width: 28rem;
            padding: 2.5rem;
            background-color: $color-nochvielvor-white;
            @media screen and (max-width: 767px) {
                padding: 1.25rem;
            }
            @media screen and (min-width: 1200px) {
                max-width: 28rem * $factor-1200;
                padding: 2rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
                max-width: 28rem * $factor-1440;
                padding: 1.7rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
                max-width: 28rem * $factor-1920;
                padding: 1.25rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
                max-width: 28rem * $factor-2400;
                padding: 1rem * $factor-2400;
            }
            .popup-body {
                h4 {
                    margin: 0 0 1rem 0;
                    color: $color-nochvielvor-pink;
                    font-size: 20px;
                    font-weight: bold;
                    &:first-child {
                        margin-top: 0;
                    }
                    &:last-child {
                        margin-bottom: 0;
                    }
                    @media screen and (min-width: 1200px) {
                        margin: 0 0 1rem * $factor-1200 0;
                        font-size: 15px * $factor-1200;
                    }
                    @media screen and (min-width: 1440px) {
                        margin: 0 0 1rem * $factor-1440 0;
                        font-size: 14px * $factor-1440;
                    }
                    @media screen and (min-width: 1920px) {
                        margin: 0 0 1rem * $factor-1920 0;
                        font-size: 12px * $factor-1920;
                    }
                    @media screen and (min-width: 2400px) {
                        margin: 0 0 1rem * $factor-2400 0;
                        font-size: 12px * $factor-2400;
                    }
                }
                p {
                    margin: 0 0 1rem 0;
                    font-size: 16px;
                    line-height: 1.6;
                    &:first-child {
                        margin-top: 0;
                    }
                    &:last-child {
                        margin-bottom: 0;
                    }
                    @media screen and (max-width: 767px) {
                        margin: 0 0 1rem * $factor-720 0;
                        font-size: 0.75rem * $factor-720;
                    }
                    @media screen and (min-width: 1200px) {
                        margin: 0 0 1rem * $factor-1200 0;
                        font-size: 13px * $factor-1200;
                    }
                    @media screen and (min-width: 1440px) {
                        margin: 0 0 1rem * $factor-1440 0;
                        font-size: 11px * $factor-1440;
                    }
                    @media screen and (min-width: 1920px) {
                        margin: 0 0 1rem * $factor-1920 0;
                        font-size: 9px * $factor-1920;
                    }
                    @media screen and (min-width: 2400px) {
                        margin: 0 0 1rem * $factor-2400 0;
                        font-size: 8px * $factor-2400;
                    }
                }
            }
            .popup-footer {
                padding-top: 2rem;
                display: flex;
                flex-direction: row;
                justify-content: flex-end;
                @media screen and (max-width: 767px) {
                    padding-top: 1.5rem;
                }
                @media screen and (min-width: 1200px) {
                    padding-top: 2rem * $factor-1200;
                }
                @media screen and (min-width: 1440px) {
                    padding-top: 2rem * $factor-1440;
                }
                @media screen and (min-width: 1920px) {
                    padding-top: 2rem * $factor-1920;
                }
                @media screen and (min-width: 2400px) {
                    padding-top: 2rem * $factor-2400;
                }
                .btn {
                    margin-right: 1rem;
                    &:last-child {
                        margin-right: 0;
                    }
                    @media screen and (max-width: 767px) {
                        margin-right: 1rem * $factor-720;
                        font-size: 16px;
                    }
                    @media screen and (min-width: 1200px) {
                        margin-right: 1rem * $factor-1200;
                        font-size: 16px;
                    }
                    @media screen and (min-width: 1440px) {
                        margin-right: 1rem * $factor-1440;
                        font-size: 16px;
                    }
                    @media screen and (min-width: 1920px) {
                        margin-right: 1rem * $factor-1920;
                        font-size: 16px;
                    }
                    @media screen and (min-width: 2400px) {
                        margin-right: 1rem * $factor-2400;
                        font-size: 16px;
                    }
                }
            }
        }
    }

</style>
